import React, { useState } from 'react';

import Dialog from 'components/Dialog';
import TextInput from 'components/TextInput';
import { AddressFields } from './steps/StepAddress';

import { 
  stepAddress as addressValidate,
  stepAddressConfirmManual as manualValidate
} from './validation/';

import {
  FlexItem,
  FormContainer,
  InputContainer,
  StepInformation,
  ScrollContainer
} from './CreateStyled';

export const useSkipConfirmDialog = ({ 
  onSubmit,
  inputErrors,
  addressValues,
  onValueChange,
  onValidateAll
}) => {
  const [open, setOpen] = useState(false);
  const [state, setState] = useState({ ...addressValues });

  const handleClose = () => setOpen(false);

  const handleSubmit = () => {
    const isValid = onValidateAll([ 
      addressValidate.bind(null, state),
      manualValidate.bind(null, state)
    ]);
    
    if (isValid) {
      setOpen(false);
      onSubmit(state);
    }
  };

  const handleChange = (name, value) => {
    onValueChange(name, value);
    setState((values) => ({ ...values, [name]: value }));
  };

  const handleSelectChange = (e) => handleChange(e.target.name, e.target.value);

  const renderDialog = () => (
    <Dialog
      open={open}
      hideCancel
      showFloatingCancel
      submitLabel="Confirm"
      onClose={handleClose}
      onSubmit={handleSubmit}
      title="Address Confirmation Details"
    >
      <StepInformation style={{
        marginTop: '1em',
        lineHeight: '1.5em',
        marginBottom: '1.5em'
      }}>
        <span style={{ fontWeight: 500 }}>Please Note</span> By skipping address confirmation Searchlight may require additional information in order to process this request.
      </StepInformation>

      <ScrollContainer>
        <FormContainer secondary>
          <InputContainer>
            <FlexItem>
              <TextInput
                bold
                required
                name="address_plan_lot_section"
                onChange={handleChange}
                label="Plan / Lot / Section"
                value={state.address_plan_lot_section}
                placeholder="Enter Plan / Lot / Section"
                errorText={inputErrors.address_plan_lot_section}
              />
            </FlexItem>
            <FlexItem>
              <TextInput
                bold
                required
                name="address_ct"
                onChange={handleChange}
                label="CT No"
                value={state.address_ct}
                placeholder="Enter CT No"
                errorText={inputErrors.address_ct}
              />
            </FlexItem>
          </InputContainer>
        </FormContainer>

        <FormContainer secondary>
          <AddressFields 
            values={state}
            onChange={handleChange}
            inputErrors={inputErrors}
            onSelectChange={handleSelectChange}
          />
        </FormContainer>
      </ScrollContainer>
    </Dialog>
  );

  return [renderDialog, setOpen];
};

export default useSkipConfirmDialog;
